// extracted by css-extract-rspack-plugin
export default {"root":"root-fv7Cyr text-base-regular"};